import dynamic from "next/dynamic";

export const SidebarFilterWidgetLazy = dynamic(
  () => import("./SidebarFilterWidget").then(({ SidebarFilterWidget }) => SidebarFilterWidget),
  {
    ssr: false
  }
);
